import { Component, Input } from '@angular/core';
import { Menu } from '../../core/models/menu.model';
import { SideMenuService } from '../../core/services/side-menu/side-menu.service';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrl: './menu-item.component.scss'
})
export class MenuItemComponent {

  @Input() menuItem: Menu | undefined;

  public isCollapsed = false;

  constructor(
    public sideMenuService: SideMenuService
  ) {}

}
